var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("app-select-bank-type", {
            attrs: { fancy: "", "use-ids": "", disabled: "" },
            model: {
              value: _vm.bank.TypeID,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "TypeID", $$v)
              },
              expression: "bank.TypeID",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("app-label", {
            attrs: { value: _vm.bank.StNr, label: _vm.$ct("labels.stnr") },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-date-picker", {
            attrs: {
              disabled: "",
              label: _vm.$ct("labels.TimeCreated"),
              fancy: "",
              locale: _vm.locale,
            },
            model: {
              value: _vm.bank.TimeCreated,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "TimeCreated", $$v)
              },
              expression: "bank.TimeCreated",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("app-select-bank-kind", {
            attrs: {
              disabled: "",
              label: _vm.$ct("labels.kind"),
              fancy: "",
              value: _vm.bank.Kind,
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        [
          _c("app-label", {
            attrs: {
              value: _vm.bank.LedgerAccountCode,
              label: _vm.$ct("labels.DefaultLedgerAccountCode"),
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "12", "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _vm.bank.Kind == 2
                ? _c(
                    "w-col",
                    { attrs: { md: "12" } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: _vm.$ct("labels.invoice"),
                          fancy: "",
                          value: _vm.bank.Invoice.ComputedFriendlyID,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.bank.Kind == 3
                ? _c(
                    "w-col",
                    { attrs: { md: "12" } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: _vm.$ct("labels.purchase"),
                          value: _vm.bank.Purchase.ComputedFriendlyID,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { md: "12" } },
                [
                  _c("app-label", {
                    attrs: {
                      label: _vm.$ct("labels.contact"),
                      value: _vm.bank.Contact.MainAddress.CompanyOrFullName,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        {
          style: { display: "flex", flexDirection: "row" },
          attrs: { md: "12" },
        },
        [
          _c("app-label", {
            style: { flexGrow: 1 },
            attrs: {
              value: _vm.bank.TotalDC,
              label: _vm.$ct("labels.amount"),
              fancy: "",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-label", {
            attrs: { value: _vm.bank.Info, label: _vm.$ct("labels.info") },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }